/* ==========================================================================
   WISE V23 — « Wise Stories » (Agent C)
   - Reels : lecture auto muette en boucle, seulement dans la zone visible,
     chargement paresseux (preload none -> metadata à l'approche).
   - Lecteur plein écran façon stories : barres de progression, glisser / flèches,
     toucher pour mettre en pause, son activé (bouton muet), Échap / glisser vers le bas
     pour fermer, piège de focus, aria.
   Sans dépendance. Initialisation : DOMContentLoaded + shopify:section:load.
   ========================================================================== */
(function () {
  'use strict';

  if (window.WiseStories) { window.WiseStories.scan(document); return; }

  var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mqMobile = window.matchMedia('(max-width: 749px)');
  var instances = [];
  var IMAGE_STORY_MS = 6000;

  var ICONS = {
    close: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>',
    mute: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 5 6 9H3v6h3l5 4z"/><path d="m22 9-6 6M16 9l6 6"/></svg>',
    sound: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 5 6 9H3v6h3l5 4z"/><path d="M15.5 8.5a5 5 0 0 1 0 7M18.5 5.5a9 9 0 0 1 0 13"/></svg>',
    pause: '<svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor" aria-hidden="true"><rect x="6" y="5" width="4" height="14" rx="1"/><rect x="14" y="5" width="4" height="14" rx="1"/></svg>',
    play: '<svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor" aria-hidden="true"><path d="M8 5.5v13l11-6.5z"/></svg>',
    bigplay: '<svg viewBox="0 0 24 24" width="30" height="30" fill="currentColor" aria-hidden="true"><path d="M8 5.5v13l11-6.5z"/></svg>',
    prev: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m15 18-6-6 6-6"/></svg>',
    next: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 18 6-6-6-6"/></svg>',
    instagram: '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/></svg>',
    tiktok: '<svg viewBox="0 0 24 24" width="13" height="13" fill="currentColor" aria-hidden="true"><path d="M16.6 3c.4 2.2 1.8 3.6 4 3.9v3.1a7.3 7.3 0 0 1-4-1.2v6.3A6 6 0 1 1 10.6 9v3.2a2.9 2.9 0 1 0 2.1 2.8V3z"/></svg>'
  };

  function saveData() {
    var c = navigator.connection;
    return !!(c && (c.saveData || /(^|-)2g$/.test(c.effectiveType || '')));
  }

  function safePlay(video) {
    try {
      var p = video.play();
      if (p && typeof p.catch === 'function') return p;
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  }

  /* ======================================================================
     Section (reels)
     ====================================================================== */
  function Stories(root) {
    this.root = root;
    this.cards = Array.prototype.slice.call(root.querySelectorAll('.ws-card[data-ws-type]'));
    this.items = this.cards.map(function (card) {
      return {
        card: card,
        type: card.getAttribute('data-ws-type'),
        sd: card.getAttribute('data-sd') || '',
        hd: card.getAttribute('data-hd') || '',
        embed: card.getAttribute('data-embed') || '',
        poster: card.getAttribute('data-poster') || '',
        name: card.getAttribute('data-name') || '',
        handle: card.getAttribute('data-handle') || '',
        platform: card.getAttribute('data-platform') || 'instagram',
        profile: card.getAttribute('data-profile') || '',
        alt: card.getAttribute('data-alt') || ''
      };
    });
    this.videos = [];
    this.ratios = new Map();
    this.suspended = false;
    this.cleanups = [];
    this.viewer = null;
    this.stage = root.querySelector('[data-ws-stage]');
    this.rail = root.querySelector('[data-ws-rail]');
    this.autoplay = root.getAttribute('data-autoplay') === 'true' && !mqReduce.matches && !saveData();
    this.init();
  }

  Stories.prototype.on = function (el, type, fn, opts) {
    el.addEventListener(type, fn, opts);
    this.cleanups.push(function () { el.removeEventListener(type, fn, opts); });
  };

  Stories.prototype.init = function () {
    var self = this;

    this.cards.forEach(function (card, index) {
      self.on(card, 'click', function (event) {
        event.preventDefault();
        self.open(index, card);
      });

      var video = card.querySelector('.ws-card__video');
      if (!video) return;
      video.muted = true;
      video.defaultMuted = true;
      video._wsCard = card;
      self.videos.push(video);

      var bar = card.querySelector('.ws-card__bar > span');
      self.on(video, 'playing', function () { card.classList.add('is-playing', 'has-frame'); });
      self.on(video, 'loadeddata', function () { if (video.currentTime > 0) card.classList.add('has-frame'); });
      self.on(video, 'pause', function () { card.classList.remove('is-playing'); });
      self.on(video, 'timeupdate', function () {
        if (bar && video.duration) card.style.setProperty('--p', (video.currentTime / video.duration).toFixed(4));
      });

      // Survol (souris) : aperçu si la lecture auto est coupée.
      if (!self.autoplay && !mqReduce.matches) {
        self.on(card, 'mouseenter', function () {
          if (window.matchMedia('(hover: hover)').matches) { video.preload = 'auto'; safePlay(video).catch(function () {}); }
        });
        self.on(card, 'mouseleave', function () { video.pause(); });
      }
    });

    // Les observateurs ciblent les cartes (la vidéo est masquée tant qu'elle n'a pas d'image).
    this.cardVideo = new Map();
    this.videos.forEach(function (v) { self.cardVideo.set(v._wsCard, v); });

    if ('IntersectionObserver' in window && this.videos.length) {
      // 1. À l'approche : on autorise le chargement (premier rendu rapide, rien avant).
      this.nearIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var v = self.cardVideo.get(entry.target);
          if (v && v.preload === 'none') v.preload = self.autoplay ? 'auto' : 'metadata';
          self.nearIO.unobserve(entry.target);
        });
      }, { rootMargin: '300px 400px' });

      // 2. Lecture uniquement des vidéos réellement visibles (plafond selon l'écran).
      if (this.autoplay) {
        this.visIO = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            self.ratios.set(entry.target, entry.isIntersecting ? entry.intersectionRatio : 0);
          });
          self.schedule();
        }, { threshold: [0, 0.25, 0.5, 0.75, 1] });
      }

      this.videos.forEach(function (v) {
        self.nearIO.observe(v._wsCard);
        if (self.visIO) self.visIO.observe(v._wsCard);
      });
    }

    // Bouton « Tout regarder »
    var all = this.root.querySelector('[data-ws-open-all]');
    if (all) this.on(all, 'click', function () { self.open(0, all); });

    // Flèches de la rangée
    this.prevBtn = this.root.querySelector('[data-ws-prev]');
    this.nextBtn = this.root.querySelector('[data-ws-next]');
    if (this.prevBtn && this.nextBtn) {
      this.on(this.prevBtn, 'click', function () { self.scrollBy(-1); });
      this.on(this.nextBtn, 'click', function () { self.scrollBy(1); });
      if (this.stage) this.on(this.stage, 'scroll', function () { self.updateArrows(); }, { passive: true });
      if (this.rail) this.on(this.rail, 'scroll', function () { self.updateArrows(); }, { passive: true });
      this.on(window, 'resize', function () { self.updateArrows(); }, { passive: true });
      this.updateArrows();
    }

    this.on(document, 'visibilitychange', function () {
      if (document.hidden) self.pauseAll(); else self.schedule();
    });
  };

  Stories.prototype.schedule = function () {
    var self = this;
    if (this._timer) return;
    // setTimeout plutôt que requestAnimationFrame : rAF est suspendu dans un onglet masqué.
    this._timer = window.setTimeout(function () {
      self._timer = 0;
      self.update();
    }, 30);
  };

  Stories.prototype.update = function () {
    if (!this.autoplay) return;
    var self = this;
    var cap = mqMobile.matches ? 2 : 4;
    var visible = [];
    this.ratios.forEach(function (ratio, card) {
      if (ratio >= 0.5) visible.push({ card: card, ratio: ratio, idx: self.cards.indexOf(card) });
    });
    visible.sort(function (a, b) { return (b.ratio - a.ratio) || (a.idx - b.idx); });
    var allowed = new Set(visible.slice(0, cap).map(function (o) { return o.card; }));

    this.videos.forEach(function (v) {
      var card = v._wsCard;
      if (!self.suspended && !document.hidden && allowed.has(card)) {
        if (v.paused) {
          if (v.preload === 'none') v.preload = 'auto';
          v.muted = true;
          safePlay(v).catch(function () {});
        }
      } else if (!v.paused) {
        v.pause();
      }
    });
  };

  Stories.prototype.pauseAll = function () {
    this.videos.forEach(function (v) { if (!v.paused) v.pause(); });
  };

  Stories.prototype.suspend = function () { this.suspended = true; this.pauseAll(); };
  Stories.prototype.resume = function () { this.suspended = false; this.schedule(); };

  Stories.prototype.scroller = function () {
    if (this.rail && window.getComputedStyle(this.rail).display !== 'contents') return this.rail;
    return this.stage;
  };

  Stories.prototype.scrollBy = function (dir) {
    var sc = this.scroller();
    if (!sc) return;
    sc.scrollBy({ left: dir * Math.max(sc.clientWidth * 0.8, 200), behavior: mqReduce.matches ? 'auto' : 'smooth' });
  };

  Stories.prototype.updateArrows = function () {
    var sc = this.scroller();
    if (!sc || !this.prevBtn) return;
    var max = sc.scrollWidth - sc.clientWidth - 8;
    this.prevBtn.disabled = sc.scrollLeft <= 8;
    this.nextBtn.disabled = sc.scrollLeft >= max;
    if (this.rail) this.rail.classList.toggle('is-end', this.rail === sc && sc.scrollLeft >= max);
    var hide = max <= 0;
    this.prevBtn.parentNode.style.visibility = hide ? 'hidden' : '';
  };

  Stories.prototype.open = function (index, opener) {
    if (!this.items.length) return;
    if (!this.viewer) this.viewer = new Viewer(this);
    this.viewer.open(index, opener);
  };

  Stories.prototype.destroy = function () {
    if (this.nearIO) this.nearIO.disconnect();
    if (this.visIO) this.visIO.disconnect();
    if (this._timer) window.clearTimeout(this._timer);
    this.pauseAll();
    this.cleanups.forEach(function (fn) { fn(); });
    this.cleanups = [];
    if (this.viewer) this.viewer.destroy();
    this.viewer = null;
  };

  /* ======================================================================
     Lecteur plein écran
     ====================================================================== */
  function Viewer(stories) {
    this.stories = stories;
    this.items = stories.items;
    this.index = 0;
    this.muted = false;
    this.paused = false;
    this.isOpen = false;
    this.imgElapsed = 0;
    this.build();
  }

  Viewer.prototype.build = function () {
    var self = this;
    var el = document.createElement('div');
    el.className = 'wsv';
    el.hidden = true;
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Wise Stories, lecteur vidéo');
    el.innerHTML =
      '<div class="wsv__backdrop" data-wsv-close-bg></div>' +
      '<img class="wsv__bg" alt="" aria-hidden="true">' +
      '<button type="button" class="wsv__side wsv__side--prev" data-wsv-prev aria-label="Vidéo précédente">' + ICONS.prev + '</button>' +
      '<div class="wsv__frame">' +
        '<div class="wsv__media" data-wsv-stage>' +
          '<video class="wsv__video" playsinline webkit-playsinline preload="auto" disablepictureinpicture></video>' +
          '<img class="wsv__img" alt="" hidden>' +
        '</div>' +
        '<div class="wsv__state" aria-hidden="true"><span class="wsv__spin"></span><span class="wsv__pauseicon">' + ICONS.bigplay + '</span></div>' +
        '<div class="wsv__top">' +
          '<div class="wsv__bars" aria-hidden="true"></div>' +
          '<div class="wsv__head">' +
            '<span class="wsv__avatar" aria-hidden="true"><span></span></span>' +
            '<div class="wsv__who"><span class="wsv__name"></span><span class="wsv__handlewrap"></span></div>' +
            '<span class="wsv__count" aria-hidden="true"></span>' +
            '<button type="button" class="wsv__ctrl" data-wsv-pause aria-label="Mettre en pause">' + ICONS.pause + '</button>' +
            '<button type="button" class="wsv__ctrl" data-wsv-mute aria-label="Couper le son" aria-pressed="false">' + ICONS.sound + '</button>' +
            '<button type="button" class="wsv__ctrl" data-wsv-close aria-label="Fermer">' + ICONS.close + '</button>' +
          '</div>' +
        '</div>' +
        '<div class="wsv__bottom"><a class="wsv__profile" target="_blank" rel="noopener" hidden></a></div>' +
      '</div>' +
      '<button type="button" class="wsv__side wsv__side--next" data-wsv-next aria-label="Vidéo suivante">' + ICONS.next + '</button>' +
      '<p class="wsv__sr" aria-live="polite"></p>';

    document.body.appendChild(el);
    this.el = el;
    this.frame = el.querySelector('.wsv__frame');
    this.stage = el.querySelector('[data-wsv-stage]');
    this.video = el.querySelector('.wsv__video');
    this.img = el.querySelector('.wsv__img');
    this.bg = el.querySelector('.wsv__bg');
    this.bars = el.querySelector('.wsv__bars');
    this.nameEl = el.querySelector('.wsv__name');
    this.handleWrap = el.querySelector('.wsv__handlewrap');
    this.avatar = el.querySelector('.wsv__avatar > span');
    this.count = el.querySelector('.wsv__count');
    this.pauseBtn = el.querySelector('[data-wsv-pause]');
    this.muteBtn = el.querySelector('[data-wsv-mute]');
    this.closeBtn = el.querySelector('[data-wsv-close]');
    this.prevBtn = el.querySelector('[data-wsv-prev]');
    this.nextBtn = el.querySelector('[data-wsv-next]');
    this.profile = el.querySelector('.wsv__profile');
    this.live = el.querySelector('.wsv__sr');

    this.closeBtn.addEventListener('click', function () { self.close(); });
    el.querySelector('[data-wsv-close-bg]').addEventListener('click', function () { self.close(); });
    this.prevBtn.addEventListener('click', function () { self.go(self.index - 1); });
    this.nextBtn.addEventListener('click', function () { self.go(self.index + 1); });
    this.pauseBtn.addEventListener('click', function () { self.togglePause(); });
    this.muteBtn.addEventListener('click', function () { self.setMuted(!self.muted, true); });

    var v = this.video;
    v.addEventListener('ended', function () { self.go(self.index + 1); });
    v.addEventListener('waiting', function () { el.classList.add('is-loading'); });
    v.addEventListener('playing', function () { el.classList.remove('is-loading'); });
    v.addEventListener('canplay', function () { el.classList.remove('is-loading'); });

    this.onKey = function (e) { self.keydown(e); };
    this.onPop = function () { if (self.isOpen) { self.pushed = false; self.close(true); } };
    this.bindGestures();
  };

  Viewer.prototype.bindGestures = function () {
    var self = this;
    var start = null;
    var frame = this.frame;

    frame.addEventListener('pointerdown', function (e) {
      if (e.button !== 0 || e.target.closest('button, a')) return;
      start = { x: e.clientX, y: e.clientY, t: Date.now(), id: e.pointerId, dx: 0, dy: 0 };
      try { frame.setPointerCapture(e.pointerId); } catch (err) { /* noop */ }
    });
    frame.addEventListener('pointermove', function (e) {
      if (!start || e.pointerId !== start.id) return;
      start.dx = e.clientX - start.x;
      start.dy = e.clientY - start.y;
      if (start.dy > 8 && start.dy > Math.abs(start.dx)) {
        self.el.classList.add('is-dragging');
        var d = Math.min(start.dy, 400);
        frame.style.transform = 'translateY(' + d + 'px) scale(' + (1 - d / 2400) + ')';
        self.el.style.setProperty('--wsv-fade', String(1 - d / 600));
      }
    });
    function end(e) {
      if (!start || e.pointerId !== start.id) return;
      var s = start;
      start = null;
      self.el.classList.remove('is-dragging');
      frame.style.transform = '';
      self.el.style.removeProperty('--wsv-fade');
      var ax = Math.abs(s.dx);
      var ay = Math.abs(s.dy);
      if (e.type === 'pointercancel') return;
      if (s.dy > 90 && ay > ax) { self.close(); return; }
      if (ax > 50 && ax > ay) { self.go(self.index + (s.dx < 0 ? 1 : -1)); return; }
      if (ax < 10 && ay < 10) {
        // Toucher : bords = précédent / suivant, centre = pause.
        var r = frame.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width;
        if (x < 0.22) self.go(self.index - 1);
        else if (x > 0.78) self.go(self.index + 1);
        else self.togglePause();
      }
    }
    frame.addEventListener('pointerup', end);
    frame.addEventListener('pointercancel', end);
  };

  Viewer.prototype.open = function (index, opener) {
    var self = this;
    this.opener = opener || document.activeElement;
    this.isOpen = true;
    this.paused = false;
    this.el.classList.remove('is-paused');
    this.stories.suspend();

    // Barres de progression
    this.bars.innerHTML = '';
    this.barEls = this.items.map(function () {
      var b = document.createElement('span');
      b.className = 'wsv__barx';
      b.appendChild(document.createElement('span'));
      self.bars.appendChild(b);
      return b;
    });

    // Verrouillage du défilement sans décalage de mise en page
    var sbw = window.innerWidth - document.documentElement.clientWidth;
    this.prevPad = document.body.style.paddingRight;
    if (sbw > 0) document.body.style.paddingRight = sbw + 'px';
    document.documentElement.classList.add('wsv-lock');

    // Arrière-plan inerte
    this.inerted = [];
    Array.prototype.forEach.call(document.body.children, function (child) {
      if (child !== self.el && !child.hasAttribute('inert') && child.tagName !== 'SCRIPT') {
        child.setAttribute('inert', '');
        self.inerted.push(child);
      }
    });

    this.el.hidden = false;
    // force reflow pour la transition
    void this.el.offsetWidth;
    this.el.classList.add('is-open');

    document.addEventListener('keydown', this.onKey, true);
    if (!window.Shopify || !window.Shopify.designMode) {
      try { history.pushState({ wsv: 1 }, ''); this.pushed = true; window.addEventListener('popstate', this.onPop); } catch (e) { this.pushed = false; }
    }

    this.go(index, true);
    this.closeBtn.focus({ preventScroll: true });
    this.loop();
  };

  Viewer.prototype.go = function (i, fromOpen) {
    var n = this.items.length;
    if (i >= n) { this.close(); return; }
    if (i < 0) i = 0;
    var self = this;
    this.index = i;
    var it = this.items[i];
    this.imgElapsed = 0;
    this.imgLast = performance.now();
    if (!fromOpen) { this.paused = false; this.el.classList.remove('is-paused'); }
    this.syncPauseBtn();

    this.barEls.forEach(function (b, k) {
      b.classList.toggle('is-done', k < i);
      b.firstChild.style.transform = k < i ? 'scaleX(1)' : 'scaleX(0)';
    });

    // Infos
    this.nameEl.textContent = it.name || it.alt || 'Wise Stories';
    this.handleWrap.innerHTML = '';
    if (it.handle) {
      var h = document.createElement(it.profile ? 'a' : 'span');
      h.className = 'wsv__handle';
      if (it.profile) { h.href = it.profile; h.target = '_blank'; h.rel = 'noopener'; }
      h.innerHTML = it.platform === 'tiktok' ? ICONS.tiktok : ICONS.instagram;
      h.appendChild(document.createTextNode(it.handle));
      this.handleWrap.appendChild(h);
    }
    this.avatar.innerHTML = '';
    if (it.poster) {
      var a = document.createElement('img');
      a.alt = '';
      a.src = it.poster.replace(/width=\d+/, 'width=96');
      this.avatar.appendChild(a);
    }
    this.count.textContent = (i + 1) + ' / ' + n;
    if (it.profile) {
      this.profile.hidden = false;
      this.profile.href = it.profile;
      this.profile.innerHTML = (it.platform === 'tiktok' ? ICONS.tiktok : ICONS.instagram) + '<span>Voir le profil</span>';
      this.profile.setAttribute('aria-label', 'Voir le profil' + (it.name ? ' de ' + it.name : '') + ' (nouvel onglet)');
    } else {
      this.profile.hidden = true;
    }
    if (it.poster) this.bg.src = it.poster; else this.bg.removeAttribute('src');
    this.prevBtn.disabled = i === 0;
    this.nextBtn.setAttribute('aria-label', i === n - 1 ? 'Fermer (dernière vidéo)' : 'Vidéo suivante');
    this.live.textContent = 'Vidéo ' + (i + 1) + ' sur ' + n + (it.name ? ', ' + it.name : '');

    // Média
    this.clearIframe();
    var v = this.video;
    if (it.type === 'video') {
      this.img.hidden = true;
      v.hidden = false;
      this.muteBtn.hidden = false;
      var src = (!mqMobile.matches && it.hd) ? it.hd : (it.sd || it.hd);
      if (it.poster) v.poster = it.poster; else v.removeAttribute('poster');
      v.src = src;
      v.currentTime = 0;
      v.muted = this.muted;
      this.el.classList.add('is-loading');
      safePlay(v).catch(function () {
        // Lecture avec le son refusée (politique navigateur) : on repasse en muet.
        if (!v.muted) {
          self.setMuted(true, false);
          safePlay(v).catch(function () { self.paused = true; self.el.classList.add('is-paused'); self.syncPauseBtn(); });
        }
      });
    } else {
      v.pause();
      v.removeAttribute('src');
      try { v.load(); } catch (e) { /* noop */ }
      v.hidden = true;
      this.el.classList.remove('is-loading');
      if (it.type === 'embed') {
        this.img.hidden = true;
        this.muteBtn.hidden = true;
        var f = document.createElement('iframe');
        f.className = 'wsv__iframe';
        f.src = it.embed;
        f.title = it.name || it.alt || 'Vidéo';
        f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        f.setAttribute('allowfullscreen', '');
        this.stage.appendChild(f);
        this.iframe = f;
      } else {
        this.muteBtn.hidden = true;
        this.img.hidden = false;
        this.img.src = it.poster;
        this.img.alt = it.alt || it.name || '';
      }
    }
  };

  Viewer.prototype.clearIframe = function () {
    if (this.iframe) { this.iframe.remove(); this.iframe = null; }
  };

  Viewer.prototype.loop = function () {
    var self = this;
    if (!this.isOpen) return;
    var it = this.items[this.index];
    var bar = this.barEls[this.index] && this.barEls[this.index].firstChild;
    var now = performance.now();
    var p = 0;
    if (it && it.type === 'video') {
      var d = this.video.duration;
      p = d && isFinite(d) ? this.video.currentTime / d : 0;
    } else if (it && it.type === 'image') {
      if (!this.paused) this.imgElapsed += now - (this.imgLast || now);
      p = this.imgElapsed / IMAGE_STORY_MS;
      if (p >= 1) { this.imgLast = now; this.go(this.index + 1); }
    } else if (it && it.type === 'embed') {
      p = 0;
    }
    this.imgLast = now;
    if (bar) bar.style.transform = 'scaleX(' + Math.min(Math.max(p, 0), 1).toFixed(4) + ')';
    this.raf = window.requestAnimationFrame(function () { self.loop(); });
  };

  Viewer.prototype.togglePause = function () {
    var it = this.items[this.index];
    if (it.type === 'embed') return;
    this.paused = !this.paused;
    this.el.classList.toggle('is-paused', this.paused);
    if (it.type === 'video') {
      if (this.paused) this.video.pause();
      else safePlay(this.video).catch(function () {});
    }
    this.syncPauseBtn();
  };

  Viewer.prototype.syncPauseBtn = function () {
    this.pauseBtn.innerHTML = this.paused ? ICONS.play : ICONS.pause;
    this.pauseBtn.setAttribute('aria-label', this.paused ? 'Reprendre la lecture' : 'Mettre en pause');
    var it = this.items[this.index];
    this.pauseBtn.hidden = !!(it && it.type === 'embed');
  };

  Viewer.prototype.setMuted = function (muted, user) {
    this.muted = muted;
    this.video.muted = muted;
    this.muteBtn.innerHTML = muted ? ICONS.mute : ICONS.sound;
    this.muteBtn.setAttribute('aria-label', muted ? 'Activer le son' : 'Couper le son');
    this.muteBtn.setAttribute('aria-pressed', muted ? 'true' : 'false');
    if (user && !muted && this.video.paused && !this.paused && this.items[this.index].type === 'video') {
      safePlay(this.video).catch(function () {});
    }
  };

  Viewer.prototype.focusables = function () {
    return Array.prototype.filter.call(
      this.el.querySelectorAll('button, a[href], iframe, [tabindex]:not([tabindex="-1"])'),
      function (n) { return !n.disabled && !n.hidden && n.offsetParent !== null; }
    );
  };

  Viewer.prototype.keydown = function (e) {
    if (!this.isOpen) return;
    var k = e.key;
    if (k === 'Escape') { e.preventDefault(); this.close(); return; }
    if (k === 'Tab') {
      var f = this.focusables();
      if (!f.length) { e.preventDefault(); return; }
      var first = f[0];
      var last = f[f.length - 1];
      var active = document.activeElement;
      if (e.shiftKey && (active === first || !this.el.contains(active))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (active === last || !this.el.contains(active))) { e.preventDefault(); first.focus(); }
      return;
    }
    var onControl = e.target && e.target.closest && e.target.closest('button, a');
    if (k === 'ArrowRight') { e.preventDefault(); this.go(this.index + 1); }
    else if (k === 'ArrowLeft') { e.preventDefault(); this.go(this.index - 1); }
    else if ((k === ' ' || k === 'Spacebar' || k === 'k') && !onControl) { e.preventDefault(); this.togglePause(); }
    else if (k === 'm' || k === 'M') { e.preventDefault(); this.setMuted(!this.muted, true); }
  };

  Viewer.prototype.close = function (fromPop) {
    if (!this.isOpen) return;
    var self = this;
    this.isOpen = false;
    window.cancelAnimationFrame(this.raf);
    document.removeEventListener('keydown', this.onKey, true);
    window.removeEventListener('popstate', this.onPop);
    if (this.pushed && !fromPop) {
      this.pushed = false;
      try { history.back(); } catch (e) { /* noop */ }
    }
    this.pushed = false;

    var v = this.video;
    v.pause();
    v.removeAttribute('src');
    try { v.load(); } catch (e) { /* noop */ }
    this.clearIframe();

    this.el.classList.remove('is-open', 'is-paused', 'is-loading');
    (this.inerted || []).forEach(function (n) { n.removeAttribute('inert'); });
    this.inerted = [];
    document.documentElement.classList.remove('wsv-lock');
    document.body.style.paddingRight = this.prevPad || '';

    var hide = function () { if (!self.isOpen) self.el.hidden = true; };
    if (mqReduce.matches) hide(); else setTimeout(hide, 300);

    if (this.opener && typeof this.opener.focus === 'function' && document.contains(this.opener)) {
      this.opener.focus({ preventScroll: true });
    }
    this.stories.resume();
  };

  Viewer.prototype.destroy = function () {
    if (this.isOpen) this.close();
    if (this.el && this.el.parentNode) this.el.parentNode.removeChild(this.el);
  };

  /* ======================================================================
     Initialisation (+ éditeur de thème)
     ====================================================================== */
  function scan(scope) {
    var roots = (scope || document).querySelectorAll('[data-wise-stories]');
    Array.prototype.forEach.call(roots, function (root) {
      if (root._wsInstance) return;
      root._wsInstance = new Stories(root);
      instances.push(root._wsInstance);
    });
  }

  function teardown(scope) {
    instances = instances.filter(function (inst) {
      if (scope.contains(inst.root)) {
        inst.destroy();
        inst.root._wsInstance = null;
        return false;
      }
      return true;
    });
  }

  window.WiseStories = { scan: scan, teardown: teardown };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); });
  } else {
    scan(document);
  }

  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { teardown(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var card = e.target && e.target.closest && e.target.closest('.ws-card');
    if (card && card.closest('[data-wise-stories]')) {
      card.scrollIntoView({ behavior: mqReduce.matches ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
    }
  });
})();
